import * as yup from 'yup'
import { MotorCarrierSchema, IShipmentMotorCarrier } from './MotorCarrierSchema'

export interface IShipmentDriver {
  id: number
  mcNumber: number
  transfixUserId: number
  name: string
  motorCarriers: IShipmentMotorCarrier[]
}

export const ShipmentDriverSchema = yup.object<IShipmentDriver>({
  id: yup.number(),
  mcNumber: yup.number(),
  transfixUserId: yup.number(),
  name: yup.string(),
  /**
   * Used to validate associations at submit time
   */
  motorCarriers: yup.array().of(MotorCarrierSchema).ensure(),
})
